export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  MAPPINGS: "/settings/mappings",
  ANALYTICS_TABLES: "/analytics/:name",
  IMPORT_PAGE: "/import-data",
  INVENTORY: "/inventory"
};